import React, { useState, useEffect } from "react";
import $ from "jquery";
import { Container, Col, Row } from "react-bootstrap";
import GoogleStat, { TrackGoogleAnalyticsEvent } from "./googleAnalytics";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

import Gotodisplay from "./gotodisplay";
import LogoImmobiliereDuParc from "../images/immobiliere_du_parc.jpeg";
import styled from "styled-components";

const Honoraires = () => {
  const [gotop, setGotop] = useState(true);
  Gotodisplay(gotop, setGotop);

  const flecheCarreRight = (
    <FontAwesomeIcon icon={faCaretRight} className="aib-color" />
  );

  const Imgstyled = styled.img`
    margin-top: 20px;
    alt: Immobilière du Parc;
    // height: 180px;  // commenté pour Noel
    height: 160px;
  `;

  const FooterTexte = styled.div``;

  $(".mnu").removeClass("menuSelected");
  $("#honorairesLink").addClass("menuSelected");

  useEffect(() => {
    $(".mnu").removeClass("menuSelected");
    $("#honorairesLink").addClass("menuSelected");
    TrackGoogleAnalyticsEvent(
      "HonorairesCategory",
      "Honoraires",
      window.location.pathname,
    );
  });

  return (
    <React.Fragment>
      <Container className="containerAib ">
        <div className="row">
          <div className="col-md-12 ">
            <ol className="breadcrumb">
              <li className="active">&nbsp;&nbsp;Nos honoraires</li>
            </ol>
          </div>
        </div>
        <Row className="aib-agence1 ">
          <Col md={{ span: 10, offset: 1 }} className="divaibblock2 ">
            <div className="row aib-agence">
              <div className="offset-md-2  col-md-8 ">
                <p className="aib-center-large ">
                  <u>TRANSACTION</u>
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-2  col-md-8 ">
                <p className="aib-center">
                  <br />
                  <b>
                    <u>Honoraires de Transactions Ventes</u>
                  </b>
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-2  col-md-8 ">
                <p className="aib-center">
                  <u>Sur Terrain</u>
                </p>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <ul className="leaders">
                  <li>
                    <span>{flecheCarreRight} Forfait unitaire :</span>
                    <span>
                      <b>9 000,00 €</b>
                    </span>
                  </li>
                  <li>
                    <span>{flecheCarreRight} En cas de pluralité :</span>
                    <span>
                      <b>7 500,00 € (par terrain)</b>
                    </span>
                  </li>
                </ul>
                <br />
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p className="aib-center">
                  <u>Sur Appartement, Maison et Commerce</u>
                </p>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <ul className="leaders">
                  <li>
                    <span>{flecheCarreRight} De 0 € à 180 000 € :</span>
                    <span>
                      <b>9 000,00 €</b>
                    </span>
                  </li>

                  <li>
                    <span>{flecheCarreRight} Au-delà de 180 001 € :</span>
                    <span>
                      <b>5,5 %</b>
                    </span>
                  </li>
                </ul>
                <br />
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <p className="aib-center-neutre">
                  <b>
                    TVA au taux en vigeur de 20% incluse.
                    <br />
                    Les honoraires sont compris à la charge du vendeur.
                    <br />
                    Tranches non cumulatives et forfaits non cumulatifs.
                    <br />
                    <u>Montant des honoraires maximum.</u>
                    <br />
                    {/* <span class="honorairebleu">Les honoraires sont compris à la charge du vendeur.</span><br/> */}
                  </b>{" "}
                  <br />
                  <br />
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p className="aib-center">
                  <br />
                  <b>
                    <u>Honoraires de Transactions Locations</u>
                  </b>
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p className="aib-center">
                  <u>Charge Propriétaire</u>
                </p>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <ul className="leaders">
                  <li>
                    <span>
                      {flecheCarreRight} Frais fixe: Publicité et entremise :
                    </span>
                    <span>
                      <b>180,00 €</b>
                    </span>
                  </li>
                  <li>
                    <span>
                      {flecheCarreRight} Etats des lieux d'entrée ou de sortie :
                    </span>
                    <span>
                      <b>3,03 €/m²</b>
                    </span>
                  </li>
                  <li>
                    <span>
                      {flecheCarreRight} Visites, constitution du dossier et
                      rédaction du bail :
                    </span>
                    <span>
                      <b>8,07 €/m²</b>
                      <br />
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p className="aib-center">
                  <u>Charge Locataire</u>
                </p>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <ul className="leaders">
                  <li>
                    <span>{flecheCarreRight} Etats des lieux d'entrée : </span>
                    <span>
                      <b>3,03 €/m²</b>
                    </span>
                  </li>
                  <li>
                    <span>
                      {flecheCarreRight} Visites, constitution du dossier et
                      rédaction du bail :
                    </span>
                    <span>
                      <b>8,07 €/m²</b>
                      <br />
                    </span>
                  </li>
                  <li>
                    <span>
                      {flecheCarreRight} Rédaction de bail seul ou avenant au
                      bail :
                    </span>
                    <span>
                      <b>200,00 €</b>
                      <br />
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <p className="aib-center-neutre">
                  <span>
                    <b>
                      TVA au taux en vigeur de 20% incluse.
                      <br />
                      <u>Montant des honoraires maximum.</u>
                      <br />
                    </b>
                  </span>
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p className="aib-center">
                  <u>
                    <b>Honoraires Autres Prestations</b>
                  </u>
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <ul className="leaders">
                  <li>
                    <span>{flecheCarreRight} Avis de valeur:</span>
                    <span>
                      <b>Offert</b>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p className="aib-center-neutre">
                  <span className="aibRedColor">
                    <b>
                      En cas de délégation, nos honoraires sont appliqués selon
                      le barème de l'agence partenaire détenteur du mandat de
                      vente.
                    </b>
                  </span>
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p>
                  <b>
                    <i>
                      Honoraires à compter du 01/01/2026
                      <br />
                      &nbsp;
                    </i>
                  </b>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        {/* <Row>
          <Col md={{ span: 10, offset: 1 }} className="divaibblock2">
            <div className="row aib-agence ">
              <div className="offset-md-2  col-md-8 ">
                <p className="aib-center-large ">
                  <u>GESTION LOCATIVE</u>
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="row aib-agence">
                <div className="offset-md-2  col-md-8 ">
                  <p className="aib-center">
                    <br />
                    <b>
                      <u>GESTION COURANTE</u> (charge bailleur) 
                    </b>
                  </p>
                </div>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <ul className="leaders">
                  <li>
                    <span>{flecheCarreRight} HONORAIRES :</span>
                    <span>
                      <b>6 % HT + TVA en vigueur sur les encaissements</b>
                    </span>
                  </li>
                  <li>
                    <span>
                      {flecheCarreRight} ASSURANCE « LOYERS IMPAYÉS » :
                    </span>
                    <span>
                      <b>2,70 % TTC des encaissements</b>
                    </span>
                  </li>
                  <li>
                    <div className="decaleTxtDroite">
                      <span>
                        <u><i>
                          Option « Détériorations Immobilières »</i></u> + 0,20 % TTC
                        <br />
                        <i>* Toutes prestations supplémentaires et hors entretien
                        courant pourra faire l’objet d’un devis ou d’une
                        facturation annexe.</i>
                      </span>
                    </div>
                  </li>
                  <li>
                    <span>{flecheCarreRight} Option envoi courrier :</span>
                    <span>
                      <b>5,00 € TTC / mois</b>
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="row aib-agence">
                <div className="offset-md-2  col-md-8 ">
                  <p className="aib-center">
                    <br />
                    <b>
                      <u>PRESTATIONS OCCASIONELLES</u> (charge bailleur)
                    </b>
                  </p>
                </div>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p className="aib-center">
                  <u>Gestion technique :</u> honoraires suivi travaux ou
                  intervention
                </p>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <ul className="leaders">
                  <li>
                    <span>{flecheCarreRight} Supérieurs à 2 000 €:</span>
                    <span>
                      <b>3 % HT sur le montant des travaux</b>
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-3 col-md-7 ">
                <ul className="leaders">
                  <li>
                    <span>{flecheCarreRight} Vacation horaire :</span>
                    <span>
                      <b>95,00 € HT</b>
                    </span>
                    <span>
                      (représentation du Mandant devant toute
                      administration, gestion des sinistres, gestion des impayés,
                      suivi dossier, etc...)
                    </span>
                  </li>

                  <li>
                    <span>
                      {flecheCarreRight} Gestion abonnements (électricité, gaz,
                      eaux) :
                    </span>
                    <span>
                      <b>10,00 € HT/contrat</b>
                    </span>
                  </li>
                  <li>
                    <span>
                      {flecheCarreRight} Frais de constitution de dossiers :
                    </span>
                    <span>
                      <b>80,00 € HT</b>
                    </span>
                    <span>
                      (type ANAH, congés bailleur, constitution et transmission
                      du dossier contentieux à l’huissier, etc...)
                    </span>
                  </li>

                  <li>
                    <span>
                      {flecheCarreRight} Aide à la déclaration des revenus
                      fonciers :
                    </span>
                    <span>
                      <b>25,00 € HT</b>
                    </span>
                  </li>
                  <li>
                    <span>
                      {flecheCarreRight} Frais de déclaration de TVA :
                    </span>
                    <span>
                      <b>15,00 € HT/trimestre</b>
                    </span>
                  </li>
                  <li>
                    <span>
                      {flecheCarreRight} Clôture de dossier de gestion :
                    </span>
                    <span>
                      <b>95,00 € HT/lot et 0,20 €/copie</b>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row aib-agence">
              <div className="offset-md-2 col-md-8 ">
                <p>
                  <b>
                    <i>
                      Honoraires à compter du 01/01/2026
                      <br />
                      &nbsp;
                    </i>
                  </b>
                </p>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-1 col-md-10 ">
                <hr className="hrHonoraires flex-grow-1 me-3" />
                <div className="d-flex justify-content-center align-items-center gap-4">
                  <span
                    className="text-center aib-center"
                    style={{ width: "60%" }}
                  >
                    En partenariat avec l’Immobilière du Parc
                  </span>
                  <Imgstyled src={LogoImmobiliereDuParc} className="mx-auto" />
                </div>
              </div>
            </div>

            <div className="row aib-agence">
              <div className="offset-md-1 col-md-10 footer-texte ">
                
                  <p>
                    55 Avenue Emile Thiebaut – 78110 LE VESINET – Tél : 01 30 15 53 90 - Mail : contact@immobiliereduparc.immo
                  </p>
                  <p>SARL au capital de 100 000 € - RCS Versailles 499 127 843 - N°TVA FR 70 499127843 - Carte pro. « transaction, gestion et syndic » n° CPI</p>
                  <p>7801 2018 000 023 811 délivrée par la CCI de Paris Ile de France - Gestion Immobilière : Garantie Financière CEGC –</p>
                  <p>59 av Pierre Mendès France 75013 PARIS - Transaction immeubles et FDC : Non détention de fonds.</p>
                
              </div>
            </div>
          </Col>
        </Row> */}

        <Row>
          <Col md={{ span: 10, offset: 1 }}>
            <div className="row aib-agence">
              <div className="offset-md-1 col-md-10">
                <p className="txtCenterHonoraires">
                  <hr className="hrHonoraires" />

                  <span>
                    SASU Aib Immobilier au capital de 900 € Code APE 6831Z RCS
                    Versailles 809 592 082
                    <br />
                    Carte CPI 7801 2016 000 011 267 délivrée par la CCI Paris
                    Ile-de-France
                    <br />
                    <u>Siège social :</u> 22 Place de l’Eglise – 78660 ABLIS
                  </span>
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Honoraires;
